import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import { useNavigate } from 'react-router-dom'

const number = [
  {
    value: 60,
    unit: 'minut',
    description: 'Oszczędności na jednej ofercie'
  },
  {
    value: 200,
    unit: 'godzin',
    description: 'Tyle może zaoszczędzić np. 5 – osobowy zespół miesięcznie'
  },
  {
    value: 12000,
    unit: 'zł',
    description: 'Tyle miesięcznie możesz zaoszczędzić'
  }
]

const offers = [
  {
    title: 'Bardziej atrakcyjne wizualnie',
    description: 'Zawierają zdjęcia produktów, opisy, ceny i linki — wszystko w jednym miejscu.'
  },
  {
    title: 'Czytelne i zrozumiałe dla klienta',
    description: 'Dzięki czemu Klienci szybciej podejmują decyzje eliminują potrzebę tłumaczenia i odpisywania na dziesiątki pytań.'
  },
  {
    title: 'Estetycznie uporządkowane',
    description: 'Robią wrażenie — wyglądają nowocześnie i profesjonalnie, nawet bez graficznego wsparcia.'
  }
]

const slides = [
  {
    title: 'Pełne bezpieczeństwo przesyłanych danych',
    description: 'Twoje dane są w pełni zabezpieczone dzięki zastosowaniu certyfikatu SSL, który zapewnia najwyższy poziom szyfrowania. Dzięki temu wszystkie przesyłane informacje są chronione przed nieautoryzowanym dostępem, co gwarantuje pełną poufność i bezpieczeństwo. Jesteśmy gotowi na każdą sytuację, zapewniając Ci spokój i pewność, że Twoje dane są bezpieczne',
    icon: '/assets/images/icons/Pełne bezpieczeństwo.png'
  },
  {
    title: 'Codzienny backup danych',
    description: 'Każdego dnia wykonujemy automatyczny backup Twoich danych, który jest bezpiecznie przechowywany w naszym nowoczesnym data center. Dzięki temu nie musisz martwić się o utratę informacji – wszystkie dane są regularnie zabezpieczane i zawsze gotowe do odzyskania, zapewniając Ci pełną pewność i spokój',
    icon: '/assets/images/icons/Codzienny Backup danych.png'
  },
  {
    title: 'Pełna zgodność z GDPR i RODO',
    description: 'Zgodność z normami GDPR oraz RODO to dla nas absolutna priorytet. Gwarantujemy pełną ochronę danych osobowych oraz przestrzeganie wszystkich przepisów dotyczących przetwarzania danych osób fizycznych. Twoje dane są przechowywane i przetwarzane zgodnie z najwyższymi standardami ochrony prywatności',
    icon: '/assets/images/icons/Zgodność z RODO GDPR.png'
  },
  {
    title: 'Stały dostęp do Twoich danych – 24/7',
    description: 'Zawsze masz dostęp do swoich danych, niezależnie od pory dnia czy nocy. Nasza infrastruktura zapewnia nieprzerwany dostęp 24 godziny na dobę, 7 dni w tygodniu, przez cały rok. Możesz być pewny, że Twoje dane będą dostępne w każdej chwili, bez żadnych zakłóceń',
    icon: '/assets/images/icons/stały dostęp do twoich danych.png'
  }
]

function useInView (ref: React.RefObject<HTMLElement>, rootMargin = '0px') {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    if (ref.current == null) return
    const observer = new window.IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { rootMargin }
    )
    observer.observe(ref.current)
    return () => {
      if (ref.current != null) observer.unobserve(ref.current)
    }
  }, [ref, rootMargin])

  return isIntersecting
}

function NumberCounter ({ value, duration = 1500 }: { value: number, duration?: number }) {
  const ref = React.useRef<HTMLSpanElement>(null)
  const isInView = useInView(ref)
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!isInView) return
    const start = 0
    const end = value
    if (start === end) return

    const incrementTime = Math.max(10, duration / end)
    const step = Math.ceil(end / (duration / incrementTime))
    let current = start

    const timer = setInterval(() => {
      current += step
      if (current >= end) {
        setCount(end)
        clearInterval(timer)
      } else {
        setCount(current)
      }
    }, incrementTime)

    return () => clearInterval(timer)
  }, [isInView, value, duration])

  return <span ref={ref}>{count.toLocaleString()}</span>
}

function BrochureSection () {
  const navigate = useNavigate()

  return (
    <section className="tw-bg-[url('../../public/assets/images/banners/9.jpg')] tw-py-20 md:tw-py-28 xl:tw-py-32">
      <div className='tw-container xl:tw-max-w-7xl tw-mx-auto tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-y-16 tw-px-4 lg:tw-px-0'>
        <div className='tw-flex tw-flex-col tw-gap-y-4 md:tw-gap-y-6 xl:tw-gap-y-8'>
          <div className='tw-h-0.5 tw-w-20 md:tw-w-40 tw-bg-white' />
          <h3 className='tw-text-lg sm:tw-text-xl md:tw-text-2xl lg:tw-text-3xl xl:tw-text-4xl tw-text-[#0e2b3d] tw-font-bold tw-text-left tw-mt-6 tw-mb-8'>Realna oszczędność czasu</h3>
        </div>

        <div>
          <div className="tw-bg-[url('../../public/assets/images/backgrounds/3.png')] tw-py-20 tw-px-8 tw-relative">
            {/* Ikona usunięta zgodnie z prośbą */}
            <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-8'>
              <h4 className='tw-text-lg md:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-white'>Kreatlo w liczbach – mierzalne efekty wdrożenia</h4>
              <div>
                <p className='tw-text-xs md:tw-text-xs xl:tw-text-sm tw-text-white'>
                  Dzięki naszej aplikacji przy założeniu pracy 5-osobowego zespołu jest to oszczędność od 12,5% do 25% całkowitego czasu pracy miesięcznie. To konkretna wartość, którą można przeznaczyć na: zatrudnienie nowych osób, marketing i rozwój, zwiększenie zysków bez zwiększania nakładu pracy.
                </p>
              </div>
            </div>

            <ul className='tw-mt-16 tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-y-2 lg:tw-gap-y-0 lg:tw-gap-x-8'>
              {number.map((item, i) => (
                <li key={i} className=''>
                  <h5 className='tw-text-xl lg:tw-text-3xl tw-font-semibold tw-text-white'>
                    <NumberCounter value={item.value} duration={1200 + i * 400} /><br />
                    <span className='tw-text-base lg:tw-text-xl'>{item.unit}</span>
                  </h5>
                  <p className='tw-font-medium tw-text-xs tw-text-white tw-line-clamp-2'>{item.description}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className='tw-bg-white tw-grid tw-grid-cols-1 lg:tw-grid-cols-2'>
            <div className='tw-px-8 tw-py-12'>
              <h4 className='tw-text-sm md:tw-text-base xl:tw-text-lg tw-font-semibold tw-text-teal'>Zdjęcia, które sprzedają – oferty, które przekonują</h4>
              <p className='tw-mt-8 tw-text-sm md:tw-text-base'>
                W świecie projektowania obrazy mówią więcej niż słowa – dlatego w Kreatlo stawiamy na wizualną stronę oferty. W procesie zakupowym obraz to pierwszy bodziec, który wpływa na decyzję klienta.
                <br /><br />
                To właśnie zdjęcie produktu przyciąga uwagę, budzi emocje i pomaga wyobrazić sobie jego zastosowanie w konkretnej przestrzeni.
              </p>
            </div>

            {/* hide on mobile */}
            <div className="tw-bg-[url('../../public/assets/images/banners/7.jpg')] tw-h-full tw-w-auto" />
          </div>

          <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2'>
            <div className='tw-bg-green tw-px-8 tw-py-12'>
              <h4 className='tw-text-sm md:tw-text-base xl:tw-text-lg tw-font-semibold tw-text-white'>Zacznij już teraz – bez opłat, bez karty, bez zobowiązań!</h4>
              <p className='tw-my-4 tw-text-sm md:tw-text-base tw-text-white'>Wypróbuj i zobacz, jak wiele możesz uprościć.</p>
              <button
                onClick={() => {
                  const registrationSection = document.querySelector('#registration-section')
                  if (registrationSection != null) {
                    registrationSection.scrollIntoView({ behavior: 'smooth' })
                  }
                }}
                className='tw-bg-white tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors hover:tw-bg-opacity-90 tw-text-green tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base'
              >
                Wypróbuj za darmo
              </button>
            </div>
            <div className='tw-bg-white tw-px-8 tw-py-12'>
              <h4 className='tw-text-sm md:tw-text-base xl:tw-text-lg tw-font-semibold tw-text-teal'>Dzięki naszej aplikacji Twoje oferty:</h4>
              <ul className='tw-mt-4'>
                {offers.map((offer, i) => (
                  <li key={i} className=''>
                    <h5 className='tw-text-xs md:tw-text-sm xl:tw-text-base tw-font-semibold tw-text-emerald'>{offer.title}</h5>
                    <p className='tw-mt-2 tw-text-sm md:tw-text-base'>{offer.description}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className='tw-bg-dark-teal tw-py-20 tw-px-8'>
            <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-8'>
              <h4 className='tw-text-sm md:tw-text-base xl:tw-text-lg tw-font-semibold tw-text-white'>Bezpieczeństwo Twoich danych – Nasz najwyższy priorytet</h4>
              <p className='tw-text-sm md:tw-text-base tw-text-white'>Zaufanie naszych użytkowników jest dla nas kluczowe, dlatego bezpieczeństwo danych traktujemy jako absolutny priorytet. Korzystamy z najnowszych technologii ochrony, aby zapewnić, że Twoje dane są zawsze w 100% bezpieczne. Poznaj szczegóły naszych rozwiązań zabezpieczających i bądź pewny, że Twoje dane są w dobrych rękach.</p>
            </div>

            <Swiper
              modules={[Pagination, Navigation, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              loop
              autoplay={{
                delay: 5000,
                disableOnInteraction: false
              }}
              pagination={{
                clickable: true,
                bulletClass: 'swiper-pagination-bullet tw-bg-white tw-opacity-50',
                bulletActiveClass: 'swiper-pagination-bullet-active tw-bg-[#47a145] tw-opacity-100'
              }}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                  spaceBetween: 24
                },
                1024: {
                  slidesPerView: 2.2,
                  spaceBetween: 28
                }
              }}
              className='mySwiper tw-mt-10 lg:tw-mt-16 tw-pb-12 lg:tw-pb-16'
            >
              {slides.map((slide, index) => (
                <SwiperSlide key={index} className='tw-self-stretch'>
                  <div className='tw-bg-white tw-rounded-lg tw-shadow-xl tw-p-6 md:tw-p-8 tw-h-full tw-flex tw-flex-col tw-text-center'>
                    {slide.icon && (
                        <div className='tw-mx-auto tw-mb-6 tw-w-12 tw-h-12'>
                            <img src={slide.icon} alt={slide.title} className='tw-w-full tw-h-full tw-object-contain' />
                          </div>
                      )}
                    <h3 className='text-xs md:text-sm xl:tw-text-base tw-font-semibold tw-text-[#0e2b3d] tw-mb-3 tw-line-clamp-2'>{slide.title}</h3>
                    <p className='tw-text-slate-600 tw-text-xs md:tw-text-xs tw-flex-grow'>{slide.description}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BrochureSection
